import type { GameModule } from '../types';
import Page from './Page';

const ludo: GameModule = {
  id:          'ludo',
  displayName: 'Ludo',
  tag:         'Board',
  theme: {
    gradient: 'from-purple-600 to-pink-900',
    emoji:    '🎲',
    logo:     '/games/ludo/Logo.png',
  },
  // Ludo's 15×15 grid + four home corners fit a vertical screen
  // perfectly; landscape squishes the board. Shell locks to portrait.
  orientation: 'portrait',
  Page,
  adminIcon: 'casino',
  adminTheme: {
    headerFrom:  'from-purple-900',
    headerTo:    'to-fuchsia-800',
    ring:        'ring-fuchsia-400',
    accent:      'bg-fuchsia-600',
    accentHover: 'hover:bg-fuchsia-500',
    dot:         'bg-fuchsia-400',
    softBg:      'bg-purple-900/30',
    rangeAccent: 'accent-fuchsia-500',
    badgeClasses: 'bg-purple-600/20 text-purple-300 border-purple-600/30',
  },
};

export default ludo;
